"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _contract = _interopRequireDefault(require("./contract"));

var _liability = _interopRequireDefault(require("./liability"));

var _lighthouse = _interopRequireDefault(require("./lighthouse"));

var _Factory = _interopRequireDefault([{
  constant: true,
  inputs: [],
  name: "gasEpoch",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x284fd42f"
}, {
  constant: true,
  inputs: [],
  name: "xrt",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x330f9588"
}, {
  constant: true,
  inputs: [],
  name: "ens",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x3f15457f"
}, {
  constant: true,
  inputs: [],
  name: "liabilityCode",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x5afa47c2"
}, {
  constant: true,
  inputs: [],
  name: "lighthouseCode",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x773fb7fd"
}, {
  constant: true,
  inputs: [],
  name: "auction",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x7d9f6db5"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "gasConsumedOf",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0x99d5bae1"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "isLighthouse",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xbbb6630f"
}, {
  constant: true,
  inputs: [],
  name: "totalGasConsumed",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xd8fe9250"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "nonceOf",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xed2a2d64"
}, {
  constant: true,
  inputs: [{
    name: "",
    type: "bytes32"
  }],
  name: "isHashConsumed",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xfa3260de"
}, {
  constant: true,
  inputs: [],
  name: "gasPrice",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xfe173b97"
}, {
  inputs: [{
    name: "_liability",
    type: "address"
  }, {
    name: "_lighthouse",
    type: "address"
  }, {
    name: "_auction",
    type: "address"
  }, {
    name: "_ens",
    type: "address"
  }, {
    name: "_xrt",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "constructor",
  signature: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "hash",
    type: "bytes32"
  }],
  name: "HashConsumed",
  type: "event",
  signature: "0xff8bad61d8f2eaa50a98cc8d31de285608e5a904d330f193043d6c9854e2586d"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "liability",
    type: "address"
  }],
  name: "NewLiability",
  type: "event",
  signature: "0xf0f0e2354315aae25080baa26761b4ef52d621c91208fb0edde9e3f3fade3219"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: "lighthouse",
    type: "address"
  }, {
    indexed: false,
    name: "name",
    type: "string"
  }],
  name: "NewLighthouse",
  type: "event",
  signature: "0xfea5f888ffd98cd2299e704fb235c2166cb5a9d9d8e9debcc08160626b8019a4"
}, {
  constant: true,
  inputs: [{
    name: "_gas",
    type: "uint256"
  }],
  name: "wnFromGas",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: false,
  stateMutability: "view",
  type: "function",
  signature: "0xd64d136d"
}, {
  constant: false,
  inputs: [{
    name: "_minimalStake",
    type: "uint256"
  }, {
    name: "_timeoutInBlocks",
    type: "uint256"
  }, {
    name: "_name",
    type: "string"
  }],
  name: "createLighthouse",
  outputs: [{
    name: "lighthouse",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0x4d5b85f1"
}, {
  constant: false,
  inputs: [{
    name: "_demand",
    type: "bytes"
  }, {
    name: "_offer",
    type: "bytes"
  }],
  name: "createLiability",
  outputs: [{
    name: "liability",
    type: "address"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0xd2b962f2"
}, {
  constant: false,
  inputs: [{
    name: "_liability",
    type: "address"
  }, {
    name: "_gas",
    type: "uint256"
  }],
  name: "liabilityCreated",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0xfeb67918"
}, {
  constant: false,
  inputs: [{
    name: "_liability",
    type: "address"
  }, {
    name: "_gas",
    type: "uint256"
  }],
  name: "liabilityFinalized",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: false,
  stateMutability: "nonpayable",
  type: "function",
  signature: "0xa51daf26"
}]);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function watchTx(web3, tx, cb) {
  var interval = setInterval(function () {
    web3.eth.getTransactionReceipt(tx, function (e, r) {
      if (e) {
        clearInterval(interval);
        cb(e);
        return;
      } else if (r) {
        clearInterval(interval);
        cb(null, r);
      }
    });
  }, 500);
}

var Factory = /*#__PURE__*/function (_Contract) {
  _inherits(Factory, _Contract);

  var _super = _createSuper(Factory);

  function Factory(web3, address) {
    _classCallCheck(this, Factory);

    return _super.call(this, web3, _Factory["default"], address);
  }

  _createClass(Factory, [{
    key: "onLiability",
    value: function onLiability(cb) {
      var _this = this;

      return this.events.NewLiability({}, function (error, result) {
        if (error) {
          cb(error);
          return;
        }

        watchTx(_this.web3, result.transactionHash, function (e, r) {
          if (e) {
            cb(e);
            return;
          }

          var liability = new _liability["default"](_this.web3, result.returnValues.liability, r.from);
          cb(null, liability);
        });
      });
    }
  }, {
    key: "onLighthouse",
    value: function onLighthouse(cb) {
      var _this2 = this;

      return this.events.NewLighthouse({}, function (error, result) {
        if (error) {
          cb(error);
          return;
        }

        watchTx(_this2.web3, result.transactionHash, function (e) {
          if (e) {
            cb(e);
            return;
          }

          var lighthouse = new _lighthouse["default"](_this2.web3, result.returnValues.lighthouse, result.returnValues.name);
          cb(null, lighthouse);
        });
      });
    }
  }]);

  return Factory;
}(_contract["default"]);

exports["default"] = Factory;